const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const ApplicationForm = {
	$domStartFormButton: $('.js-application-form-start'),
	$domNextFormButton: $('.js-application-form-next'),
	$domGFormNextButton: $('.gform_next_button'),
	$domBackFormButton: $('.js-application-form-back'),
	$domGFormPrevButton: $('.gform_previous_button'),
	$domFirstScreen: $('.js-application-form-first-screen'),
	$domSaveLaterButton: $('.js-application-form-save'),
	$domGFormSaveLaterButton: $('.gform_save_link'),
	$domPageTitleContainer: $('.js-application-form-page-title-container'),
	$domGFormFacilityAutoPopulate: $('.js-facility-auto-populate'),
	classActive: 'active',

	init() {
		this.startForm();
		this.ContinueApplicationForm();
	},

	ContinueApplicationForm() {
		$(document).ready(function() {
			// Check if the URL contains ?gf_token=
			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('gf_token')) {
			// Change text of .js-application-form-start to 'Continue my Application'
				const $startButton = $('.js-application-form-start');
				if ($startButton.length) {
					$startButton.text('Continue My Application');
				}
				// Update the paragraph text
				const $welcomeTermsParagraph = $('.application-form__welcome-terms');
				if ($welcomeTermsParagraph.length) {
					const baseUrl = `${window.location.origin}`;
					$welcomeTermsParagraph.html(`By clicking "Continue My Application" you're agreeing to OK Kosher's <a href="${baseUrl}/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a> and our <a href="${baseUrl}/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.`);
				}
			}
		});
	},

	openCloseSidebar() {
		$(document).on('click', (e) => {
			if (!$(e.target).closest('.application-form__right-container').length) {
				$('.application-form__right-container').removeClass('active');
			}
		});
		$('.js-close-sidebar-tips').on('click', () => {
			$('.application-form__right-container').removeClass('active');
		});

		$('.js-application-form-help').on('click', (e) => {
			e.stopPropagation();
			$('.application-form__right-container').addClass('active');
		});
	},

	startForm() {
		this.$domStartFormButton.on('click', () => {
			this.$domFirstScreen.removeClass(this.classActive);
			this.updatePageState();
			this.saveLaterForm();
			this.appendPageTitle();
			this.openCloseSidebar();
			this.getAndSetProgressBarPercentage();
			this.submitForm();
			this.submitSerializedForm();
			this.handleRepeater();
			this.initializeApplicationFormSelects();
			this.$domNextFormButton.on('click', () => {
				this.navigatePageForm('next');
			});
			this.$domBackFormButton.on('click', () => {
				this.navigatePageForm('back');
			});
		});
	},

	submitForm() {
		$(document).on('click', '.js-application-form-submit', function(e) {
			e.preventDefault();

			const $realSubmit = $('input.gform_button[type="submit"]');

			if (typeof window.gform !== 'undefined' && typeof window.gform.submission !== 'undefined') {
				window.gform.submission.handleButtonClick($realSubmit[0]); // Pass the native DOM element
			} else {
				// Fallback in case handleButtonClick doesn't exist
				$realSubmit.trigger('click');
			}

			$('.js-application-form-loader').addClass('active');
		});
	},

	submitSerializedForm() {
		$(document).on('click', '.js-application-form-pdf-link', function(e) {
			e.preventDefault();
			const serializedData = $('.application-form-multistep_wrapper .application-form-multistep').serializeArray();
			$('#serializedDataInput').val(JSON.stringify(serializedData));
			$('#serializedDataForm').trigger('submit');
		});
	},

	initializeApplicationFormSelects() {
		$('.application-form-multistep .gform-body .gfield_select').select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'application-form-select-dropdown',
		});
		$('.application-form-multistep .gform-body .name_prefix select').select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'application-form-select-dropdown',
			placeholder: 'Prefix',
		});
		$('.js-product-category-select select').select2({
			dropdownCssClass: 'application-form-select-dropdown',
			placeholder: 'Product Category *',
		});
		$('.application-form-multistep .address_country select').select2({
			dropdownCssClass: 'application-form-select-dropdown',
			placeholder: 'Country *',
		});
	},

	addTitleToPreviewRepeaterItems() {
		if ($('.application-form-preview').is(':visible')) {
			$('.gfield--input-type-html tr td ol>font>li').each(function(index) {
				if ($(this).find('p').length === 0) {
					$(this).prepend(`<p class="application-form-preview-repeater-title">Facility ${index + 1}</p>`);
				}
			});
		}
	},
	// appendPageTitle works is correct
	appendPageTitle() {
		const $activePage = $('.application-form__left-list-item.active:not(.pass)');
		const $nextPage = $activePage.next('.application-form__left-list-item');
		const activeText = $activePage.find('.application-form__left-list-item-text').text();

		this.$domPageTitleContainer.text(activeText);
		$('.application-form__form-top-info--mobile-text-title').text(activeText);
		$('.js-application-form-page-number').text($activePage.find('.application-form__left-list-item-icon').text());
		if ($nextPage.find('.application-form__left-list-item-text').text()) {
			$('.js-application-form-next-page-name').text(
				`Next: ${$nextPage.length ? $nextPage.find('.application-form__left-list-item-text').text() : ''}`
			);
		} else {
			$('.js-application-form-next-page-name').text('');
		}
	},

	// saveLaterForm code works
	saveLaterForm() {
		this.$domSaveLaterButton.on('click', () => {
			const visiblePage = $('div[id^="gform_page_"]:visible');
			visiblePage.find('.gform_save_link').trigger('click');
		});
	},

	getAndSetProgressBarPercentage() {
		const $progressBarElement = $('.gf_progressbar .gf_progressbar_percentage').attr('style').match(/width:\s*([^;]+)/);
		if ($progressBarElement) {
			const currentPercentage = parseFloat($progressBarElement[1]);
			$('.application-form__bottom-line-fill').css('width', `${currentPercentage}%`);
			$('.application-form__bottom-line-percent').html(`${currentPercentage}%`);
			const circularProgressPercentage = Math.min(currentPercentage * 3.6, 360);
			$('.circular-progress').css('--progress', `${circularProgressPercentage}deg`);
		}
	},

	updatePageState() {
		const visiblePage = $('div[id^="gform_page_"]:visible');
		if (visiblePage.length) {
			const match = visiblePage.attr('id').match(/gform_page_\d+_(\d+)/);
			const currentPageNumber = match && match[1] ? parseInt(match[1], 10) : 1;
			// Update the active and pass classes
			$('ul.application-form__left-list .application-form__left-list-item').each(function(index) {
				const itemNumber = index + 1;
				$(this).toggleClass('active', itemNumber === currentPageNumber).toggleClass('pass', itemNumber < currentPageNumber);
			});
			// Update button states
			const pageDivs = $('div[id^="gform_page_"]');
			const pageNumbers = pageDivs.map(function() {
				return parseInt($(this).attr('id').split('_').pop(), 10);
			}).get().filter(Number.isFinite);
			if (pageNumbers.length) {
				const minPageNumber = Math.min(...pageNumbers);
				const maxPageNumber = Math.max(...pageNumbers);
				$('.application-form__bottom-button--back').toggleClass('disabled', currentPageNumber === minPageNumber);
				$('.application-form__bottom-button--next').toggleClass('disabled', currentPageNumber === maxPageNumber);
			}
			// Scroll to top
			$('.application-form__form').scrollTop(0);
			// Update page title
			this.appendPageTitle();
			// Update progress bar percentage
			this.getAndSetProgressBarPercentage();
			// Update sidebar content
			this.sidebarBox();
			// Remove loader
			$('.js-application-form-loader').removeClass('active');
			// Remove question items
			$('.application-form__right-wrapper').find('.question-item').remove();
			// Add title to preview repeater items
			// this.addTitleToPreviewRepeaterItems();
			// Ensure the repeater div is within the active page
			const $repeaterDiv = $('.application-form-repeater-end');
			const $activePage = $('div[id^="gform_page_"]:visible');
			if ($activePage.length && $activePage.find($repeaterDiv).length) {
				$repeaterDiv.addClass('active');
				this.initializeApplicationFormSelects();
				setTimeout(() => {
					const $repeaterCounterInput = $('.js-repeater-counter .ginput_container_number input');
					// Trigger input and change events
					$repeaterCounterInput.trigger('input').trigger('change');
				}, 100);
			} else {
				$repeaterDiv.removeClass('active');
			}
			// Initialize application form selects
			this.initializeApplicationFormSelects();
			// Call wps_aa if it exists
			$(document).ready(function() {
				if (typeof wps_aa === 'function') {//eslint-disable-line
					setTimeout(wps_aa(), 0); //eslint-disable-line
				}
			});
		}
	},

	// sidebarBox functions
	sidebarBox() {
		const $rightWrapper = $('.application-form__right-wrapper');
		const $tipItem = $('.js-application-form-tip-item');
		const $activePage = () => $('div[id^="gform_page_"]:visible');


		// Clear existing sidebar content
		const clearSidebarContent = () => {
			$rightWrapper.find('.dynamic-item').remove();
			$tipItem.removeClass('active')
				.find('.application-form__right-wrapper-item-title-text, .application-form__right-wrapper-item-text')
				.empty();
		};

		// Append content to the sidebar (Mobile)
		const appendSidebarContentMobile = () => {
			clearSidebarContent();
			$activePage().find('.js-sidebar-item').each(function() {
				const sidebarTitle = $(this).find('span').html();
				const sidebarContent = $(this).find('p').html();

				const $newItem = $(`
            <div class="application-form__right-wrapper-item">
                ${sidebarTitle ? `
                    <div class="application-form__right-wrapper-item-title">
                        <span class="application-form__right-wrapper-item-icon svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512a256 256 0 100-512 256 256 0 100 512zm-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1164 0 32 32 0 11-64 0z"></path></svg>
                        </span>
                        <p class="application-form__right-wrapper-item-title-text">${sidebarTitle}</p>
                    </div>` : ''}
                <p class="application-form__right-wrapper-item-text">${sidebarContent}</p>
            </div>
        `);

				$rightWrapper.append($newItem);
			});
		};

		// Add span with js-question-btn inside each .js-question div's label
		const addQuestionButtons = () => {
			$('.js-question').each(function() {
				const $label = $(this).find('.gfield_label, .gsection_title');
				if (!$label.find('.js-question-btn').length) {
					$label.append(`
                <span class="application-form__right-wrapper-item-icon js-question-btn">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512a256 256 0 100-512 256 256 0 100 512zm-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1164 0 32 32 0 11-64 0z"></path></svg>
				</span>
            `);
				}
			});
		};
		// Handle question button clicks
		const handleQuestionButtonClick = () => {
			$('.js-question-btn').off('click').on('click', function(event) {
				$('.application-form__right-wrapper-item.question-item').remove();

				const $questionItem = $(this).closest('.js-question').next('.js-question-item');
				const questionTitle = $questionItem.find('span').html();
				const questionContent = $questionItem.find('p').html();

				const $newCard = $(`
            <div class="application-form__right-wrapper-item question-item">
                ${questionTitle ? `
                    <div class="application-form__right-wrapper-item-title">
                        <span class="application-form__right-wrapper-item-icon svg-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512a256 256 0 100-512 256 256 0 100 512zm-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1164 0 32 32 0 11-64 0z"></path></svg>
                        </span>
                        <p class="application-form__right-wrapper-item-title-text">${questionTitle}</p>
                    </div>` : ''}
                <p class="application-form__right-wrapper-item-text">${questionContent}</p>
            </div>`);

				$rightWrapper.children().eq(1).after($newCard);
				if (window.innerWidth <= 1450) {
					event.stopPropagation();
					$('.application-form__right-container').addClass('active');
				}
			});
		};

		const observeScrollAndAppendSidebar = () => {
			const $formElement = $('.application-form__form');

			if (!$formElement.length) {
				return;
			}

			// Function to check if an element is fully visible in the viewport
			const isElementFullyInViewport = (el) => {
				const rect = el.getBoundingClientRect();
				const windowHeight = $(window).height();
				const windowWidth = $(window).width();
				return (
					rect.top >= 0 && rect.bottom <= windowHeight && rect.left >= 0 && rect.right <= windowWidth
				);
			};

			const appendOrRemoveSidebarContent = () => {
				const $activePage = $('div[id^="gform_page_"]:visible');
				const $sidebarParent = $activePage.find('.js-sidebar-parent');
				const $sidebarItem = $sidebarParent.next('.js-sidebar-item');

				// Find the tip item related to the sidebar
				const $tipItem = $('.js-application-form-tip-item');

				if ($sidebarParent.length && isElementFullyInViewport($sidebarParent[0])) {
					const sidebarTitle = $sidebarItem.find('span').html() || 'Default Title';
					const sidebarContent = $sidebarItem.find('p').html() || 'Default Content';

					// Add active class and update title/content
					$tipItem
						.addClass('active')
						.find('.application-form__right-wrapper-item-title-text')
						.html(sidebarTitle)
						.end()
						.find('.application-form__right-wrapper-item-text')
						.html(sidebarContent);
				} else {
					// Remove active class and clear title/content only for the related item
					$tipItem.removeClass('active').find('.application-form__right-wrapper-item-title-text, .application-form__right-wrapper-item-text').html('');
				}
			};
			// Attach scroll listener and perform initial check
			$formElement.on('scroll', appendOrRemoveSidebarContent);
			appendOrRemoveSidebarContent();
		};

		// Update sidebar content dynamically
		const updateSidebarContent = () => {
			if (window.innerWidth > 1450) {
				observeScrollAndAppendSidebar();
			} else {
				appendSidebarContentMobile();
			}
		};

		// Initialization
		addQuestionButtons();
		handleQuestionButtonClick();
		$(window).on('resize', updateSidebarContent);
		updateSidebarContent();
	},

	handleRepeater() {
		const $repeaterCounterSelector = '.js-repeater-counter .ginput_container_number input[type="number"]';
		const $repeaterAddSelector = '.repeater-field-footer .gf-repeater-field-button-add';
		const $repeaterRemoveSelector = '.repeater-field-header-acctions-remove';
		const $repeaterItemSelector = '.repeater-field-item';
		const $addButton = $($repeaterAddSelector);

		const updateCounter = () => {
			const repeaterItemCount = $($repeaterItemSelector).length; // Dynamically count repeater items
			$($repeaterCounterSelector).val(repeaterItemCount); // Update the counter's value
			updateAddButtonVisibility(repeaterItemCount);
		};

		// Function to hide or show the add button based on the repeater item count
		const updateAddButtonVisibility = (count) => {
			if (count >= 30) {
				$addButton.hide(); // Hide the Add button if items are 30 or more
			} else {
				$addButton.show(); // Show the Add button if items are less than 30
			}
		};

		let debounceTimeout;

		const addRemoveRepeaterItemOverInput = () => {
			this.initializeApplicationFormSelects();
			$(document).on('input', $repeaterCounterSelector, () => {
				clearTimeout(debounceTimeout);
				debounceTimeout = setTimeout(() => {
					$('.js-application-form-loader').addClass('active');
					$('.application-form-repeater-end:has(.active)').removeClass('active');

					const counterValue = parseInt($($repeaterCounterSelector).val(), 10) || 0; // Ensure valid number
					const repeaterItemCount = $($repeaterItemSelector).length; // Dynamically count items
					// Delay to allow loader to show up
					setTimeout(() => {
						if (counterValue > repeaterItemCount) {
							for (let i = 0; i < counterValue - repeaterItemCount; i++) {
								$($repeaterAddSelector).trigger('click'); // Add item
							}
						} else if (counterValue < repeaterItemCount) {
							for (let i = 0; i < repeaterItemCount - counterValue; i++) {
								const $lastRepeaterItem = $($repeaterItemSelector).last();
								$lastRepeaterItem.find($repeaterRemoveSelector).trigger('click');
							}
						}
						$($repeaterItemSelector).not(':first').find('.repeater-field-header-acctions-toogle.icon-down-open').trigger('click');
						$('.application-form-repeater-end:not(.active)').addClass('active');
						$('.js-application-form-loader').removeClass('active'); // Hide loader after updates
						this.initializeApplicationFormSelects();
						this.initAutocompleteRepeater();
					}, 200); // Allow loader to stay visible for a short time
					updateAddButtonVisibility(counterValue); // Update button visibility based on counter value
					this.initAutocompleteRepeater();
				}, 300); // Delay to prevent multiple triggers on rapid input changes
			});
		};

		const handleManualAddRemove = () => {
			$(document).on('click', $repeaterAddSelector, () => {
				setTimeout(updateCounter, 0);
				this.initializeApplicationFormSelects();
				$(document).ready(function() {
					if (typeof wps_aa === 'function') {//eslint-disable-line
						setTimeout(wps_aa(), 0); //eslint-disable-line
					}
				});
				this.initAutocompleteRepeater();
			});
			$(document).on('click', $repeaterRemoveSelector, () => {
				setTimeout(updateCounter, 0);
				this.initializeApplicationFormSelects();
				$(document).ready(function() {
					if (typeof wps_aa === 'function') {//eslint-disable-line
						setTimeout(wps_aa(), 0); //eslint-disable-line
					}
				});
				this.initAutocompleteRepeater();
			});
		};

		const observeDOM = (selector, callback) => {
			const targetNode = document.body; // Observe the entire body
			const observerOptions = {childList: true, subtree: true};
			const observer = new MutationObserver(() => {
				if ($(selector).length) {
					callback(); // Trigger callback when the element appears
					observer.disconnect(); // Stop observing after elements are found
				}
			});
			observer.observe(targetNode, observerOptions);
		};
		observeDOM($repeaterCounterSelector, () => {
			addRemoveRepeaterItemOverInput();
			handleManualAddRemove();
		});
	},

	// Validation function for repeater fields
	validateRepeaterFields() {
		let allFieldsValid = true;
		const $repeaterContainer = $('.application-form-repeater-end');

		if ($repeaterContainer.length === 0) {
			return true;
		}

		$repeaterContainer.find(
			'.ginput_container .repeater-field-warp-item-data .repeater-field-warp-item .repeater-field-item .repeater-field-content .container-repeater-field'
		).each(function() {
			const $item = $(this);
			const $fields = $item.find(
				'.gfield .ginput_container input, .gfield .ginput_container textarea, .gfield .ginput_container select'
			);

			$fields.each(function() {
				const $field = $(this);
				const $parentGField = $field.closest('.gfield');
				const $gInputContainer = $field.closest('.ginput_container');

				// Remove existing error spans
				$gInputContainer.find('.repeater-field-error').remove();

				// Skip validations for specific conditions (ignored fields)
				if (
					$field.is(':disabled') ||
					($field.is('select') && $field.closest('.name_prefix_select').length) ||
					($field.is('input') && $field.closest('.address_line_2').length) ||
					($field.is('textarea') && $parentGField.hasClass('additional-comments-textarea')) ||
					$parentGField.data('conditional-logic') === 'hidden'
				) {
					return true;
				}

				// Validate First Name field
				if ($field.closest('.gform-grid-col').hasClass('name_first')) {
					$field.siblings('.repeater-field-error--first').remove();
					if (!$field.val().trim()) {
						allFieldsValid = false;
						if (!$field.siblings('.repeater-field-error--first').length) {
							$field.after('<span class="repeater-field-error--first">First Name is required.</span>');
						}
					}
				}
				// Validate Last Name field
				if ($field.closest('.gform-grid-col').hasClass('name_last')) {
					$field.siblings('.repeater-field-error--last').remove();
					if (!$field.val().trim()) {
						allFieldsValid = false;
						if (!$field.siblings('.repeater-field-error--last').length) {
							$field.after('<span class="repeater-field-error--last">Last Name is required.</span>');
						}
					}
				}

				// Validate text, textarea, and select fields (required)
				if (
					!$field.is(':checkbox') &&
					!$field.is(':radio') &&
					!$field.parent().parent().hasClass('ginput_container_address') &&
					!$field.closest('.gform-grid-col').hasClass('name_last') &&
					!$field.closest('.gform-grid-col').hasClass('name_first') &&
					!$field.val().trim()
				) {
					allFieldsValid = false;
					// Find the parent that directly holds the input/select/textarea
					const $fieldParent = $field.parent();
					// Append the error message to this parent
					if ($fieldParent.length && !$fieldParent.find('.repeater-field-error').length) {
						$fieldParent.append('<span class="repeater-field-error">This field is required.</span>');
					}
				}

				// Validate checkbox groups (at least one checked)
				if ($field.is(':checkbox')) {
					const $checkboxGroup = $parentGField.find('.gfield_checkbox input[type="checkbox"]');
					if ($checkboxGroup.filter(':checked').length === 0) {
						allFieldsValid = false;
						if (!$gInputContainer.find('.repeater-field-error').length) {
							$gInputContainer.append('<span class="repeater-field-error">This field is required.</span>');
						}
					}
				}

				// Validate radio button groups (at least one selected)
				if ($field.is(':radio')) {
					const $radioGroup = $parentGField.find('.gfield_radio input[type="radio"]');
					if ($radioGroup.filter(':checked').length === 0) {
						allFieldsValid = false;
						if (!$gInputContainer.find('.repeater-field-error').length) {
							$gInputContainer.append('<span class="repeater-field-error">This field is required.</span>');
						}
					}
				}

				// Validate address fields
				if ($parentGField.hasClass('gfield--type-address')) {
					const $addressFields = $parentGField.find('.ginput_container_address').find('input, select');
					const missingFields = [];
					$addressFields.each(function() {
						const $addressField = $(this);
						const hasError = $addressField.hasClass('error');
						if (hasError) {
							$addressField.removeClass('error');
						}
						const fieldClass = $addressField.next().text();
						if (!$addressField.val().trim()) {
							if (fieldClass && fieldClass !== 'Address Line 2') {
								$addressField.addClass('error');
								missingFields.push(fieldClass);
							}
						}
					});

					if (missingFields.length > 0) {
						allFieldsValid = false;
						$gInputContainer.find('.repeater-field-error').remove();
						$gInputContainer.append(
							'<span class="repeater-field-error">' + missingFields.join(', ') + ' is required.</span>'
						);
					}
				}
			});
		});

		return allFieldsValid;
	},

	scrollToFirstError() {
		const $firstError = $('.repeater-field-error').first();
		if ($firstError.length) {
			const $repeaterItem = $firstError.closest('.repeater-field-item');
			const $repeaterToggle = $repeaterItem.find('.repeater-field-header-acctions-toogle.icon-up-open');
			if ($repeaterToggle.length) {
				$repeaterToggle.trigger('click');
			}

			// Get the scroll container
			const $scrollContainer = $('.application-form__form');
			const containerOffsetTop = $scrollContainer.offset().top;
			const containerScrollTop = $scrollContainer.scrollTop();
			const containerHeight = $scrollContainer.height();
			const errorOffsetTop = $firstError.offset().top - containerOffsetTop + containerScrollTop;

			// Calculate target scroll position to center the error
			const targetScrollTop = errorOffsetTop - containerHeight / 2 + $firstError.outerHeight() / 2;

			// Check if the target is already visible within the viewport
			const isTargetVisible =
				errorOffsetTop >= containerScrollTop &&
				errorOffsetTop <= containerScrollTop + containerHeight;

			// Scroll only if the error is not centered
			setTimeout(() => {
				if (!isTargetVisible || Math.abs(containerScrollTop - targetScrollTop) > 1) {
					$scrollContainer.animate(
						{
							scrollTop: targetScrollTop
						},
						250
					);
				}
			}, 300); // Adjust delay based on repeater toggle animation speed
		}
	},

	// Function to trigger validation on the current page
	triggerValidationOnRepeaterPage() {
		const $activePage = $('div[id^="gform_page_"]:visible');
		const $repeaterFields = $activePage.find(
			'.application-form-repeater-end .ginput_container .repeater-field-warp-item-data .repeater-field-warp-item'
		);

		if ($repeaterFields.length > 0) {
			return this.validateRepeaterFields();
		}

		return true;
	},

	// Function to handle page navigation
	navigatePageForm(direction) {
		const buttonSelector = direction === 'next' ? '.gform_next_button' : '.gform_previous_button';
		const $visibleButton = $('div[id^="gform_page_"]:visible ' + buttonSelector);

		if (direction === 'next') {
			const isValid = this.triggerValidationOnRepeaterPage();
			if (!isValid) {
				// Prevent navigation if validation fails
				this.scrollToFirstError();
				$('.js-application-form-loader').removeClass('active');
				return;
			}
		}

		if ($visibleButton.length) {
			$('.js-application-form-loader').addClass('active');
			$visibleButton.trigger('click');

			let pageUpdated = false;

			$(document).on('gform_page_loaded', (event, formId, currentPage) => { //eslint-disable-line
				if (!pageUpdated) {
					this.updatePageState();
					pageUpdated = true;
				}
			});

			$(document).on('gform_page_change', (event, formId, currentPage) => { //eslint-disable-line
				pageUpdated = false;
			});

			this.initializeApplicationFormSelects();

			$(document).ready(() => {
				if (typeof wps_aa === 'function') { //eslint-disable-line
					setTimeout(wps_aa, 0); //eslint-disable-line
				}
			});
		}
	},

	initAutocompleteRepeater() {
		// Iterate through each repeater field item
		$('.application-form-repeater-end .repeater-field-item').each(function() {
			// Find the span with class 'address_line_1' that wraps the input field
			$(this).find('.address_line_1').each(function() {

				// Get the ID of the input inside the span
				const inputId = $(this).find('input[type="text"]').attr('id');
				const inputSelector = $(this).find('input[type="text"]');
				if (inputId) {
					const city = inputSelector.closest('.ginput_container').find('.address_city input[type="text"]').attr('id');
					const state = inputSelector.closest('.ginput_container').find('.address_state input[type="text"]').attr('id');
					const zip = inputSelector.closest('.ginput_container').find('.address_zip input[type="text"]').attr('id');
					const country = inputSelector.closest('.ginput_container').find('.address_country select').attr('id');

					const addressGroup = {
						init: `#${inputId}`,
						delay: 0,
						fields: {
							address: {selector: `#${inputId}`, data: '{address1:long_name}'},
							city: {selector: `#${city}`, data: '{locality:long_name}'},
							state: {selector: `#${state}`, data: '{administrative_area_level_1:long_name}'},
							zip: {selector: `#${zip}`, data: '{postal_code:long_name}'},
							country: {selector: `#${country}`, data: '{country:long_name}'}
						}
					};

					// Trigger the original autocomplete function
					if (typeof wps_aa_init_autocomplete === 'function') { //eslint-disable-line
						wps_aa_init_autocomplete(addressGroup); //eslint-disable-line
					} else {
						console.error('wps_aa_init_autocomplete function is not available.');
					}
				} else {
					console.warn('Input field without an ID found inside .application-form-repeater-end');
				}
			});
		});
	}
};

export default ApplicationForm;
